import useLocalStorage from "./useLocalStorage";

export default function useHasAccess() {
  const [accessToken] = useLocalStorage("accessToken", null);
  return accessToken === process.env.REACT_APP_ACCESS_TOKEN;
}
